<template>
  <v-card >
    <request-status :request='updateRequest' @ok="$emit('saved')" />

    <v-card-title class='title' v-if='title' >{{title}}</v-card-title>
    <v-card-text>

      <v-layout class='mb-3' >
        <v-flex xs12>
          <v-card>
            <v-text-field
              v-model='address.name'
              label="Location name"
              hint='This is the business name that people will recognize. E.g.: Virgin Active Gym Melrose Arch'
              persistent-hint
              box
              required >
            </v-text-field>
            <v-divider></v-divider>
            <!-- <v-checkbox v-model='address.is_online' persistent-hint
              hint='If you do not want to display address information for this location, or if it is a virtual location (online)'
              class='mt-1 mr-4'
              label='Do not associate a physical address with this location' ></v-checkbox> -->
          </v-card>
        </v-flex>
      </v-layout>
      <v-card v-if='!address.is_online' flat>
        <v-card-title class='subheading pb-0 pt-4' >
          Address details
        </v-card-title>
        <v-card-text >
          <v-subheader class='pl-0 overline' >
            Search Google places for your address
          </v-subheader>
          <address-picker v-model='place' />
        </v-card-text >

          <v-divider></v-divider>
          <v-layout v-show='address.address || address.latitude' >
            <v-flex>
              <v-form >
                <v-subheader class='pl-0 overline' >
                  Confirm that these details are correct and hit save
                </v-subheader>
                <v-layout row wrap >
                  <v-flex xs12 >
                    <v-text-field v-model ='address.address' :error-messages='errors.address' label="Address" hint='The physical address' required ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field v-model='address.latitude' :error-messages='errors.latitude' label="Latitude" required ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field v-model='address.longitude' :error-messages='errors.longitude' label="Longitude" required ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>

      </v-card>

      <template >
        <v-textarea outline hide-details v-model='address.notes'
            class='mt-3'
            :label='extraInfoNotes'
            placeholder='For example: When you arrive at the address. We are in the red building no. 401 A. If you ring the doorbell the receptionist will let you in.'
            multi-line persistent-hint >
        </v-textarea>
        <ul class='tiny' >
          <li>This information can be used in your notifications (<code>appointment.product.address.notes</code>)</li>
          <li>This information will appear on your appointment detail page.</li>
          <li>You can use markdown.</li>
        </ul>
      </template>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <slot name='form-secondary-action' >
        <v-btn flat @click="$emit('close')" >Done</v-btn>
      </slot>
      <v-spacer></v-spacer>
      <vuex-btn @save='$emit("save", address)' :req-id='reqId' text='Save' ></vuex-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import AddressPicker from '@/components/pickers/AddressPicker'
export default {
  name: 'LocationView',
  components: {AddressPicker},
  props: {
    location: { type: Object, default: () => { return { address: {} } } },
    title: { type: String }
  },
  data () {
    return {
      place: {},
      showDetails: false,
      showDeleteConfirmation: false,
      confirmDelete: null,
      reqId: 'update-service-request',
      address: {
        id: 0,
        name: '',
        address: '',
        latitude: '',
        longitude: '',
        place_data: {},
        place_id: ''
      }
    }
  },
  mounted () {
    this.reloadData()
  },
  watch: {
    place () {
      if (this.place) {
        this.showDetails = true
        if (!this.address.name) {
          this.address.name = this.place.name
        }
        this.address.address = this.place.formatted_address
        this.address.place_id = this.place.id
        this.address.place_data = this.place
        if (this.place.geometry && this.place.geometry.location) {
          this.address.latitude = this.place.geometry.location.lat()
          this.address.longitude = this.place.geometry.location.lng()
        }
      }
    },
    location () {
      this.reloadData()
    }
  },
  computed: {
    hideDetails () {
      return (this.location &&
              this.location.address &&
              this.location.address !== '{}' &&
              this.location.address !== '')
    },
    extraInfoNotes () {
      if (this.address.is_online) {
        return 'Any extra information people might need in order connect with you (optional)'
      } else {
        return 'Any extra information people might need in order find this location (optional)'
      }
    },
    updateRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    errors () {
      let data = {
        'address': [],
        'latitude': [],
        'longitude': []
      }
      if (this.updateRequest.status === 400) {
        data = this.getObjectPath(this.updateRequest, 'result.data', data)
      }
      if (this.updateRequest.status > 499) {
        data['general'] = 'The remote server did not respond correctly. Please try again or contact support if the problem persists'
      }
      return data
    }
  },
  methods: {
    reloadData () {
      if (this.location) {
        this.address = this.location
        this.place = this.location.place_data
        // this is rather obtuse!
        this.showDetails = !this.hideDetails
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// LocationEdit.vue?b81d50bc